let ctx = null;

export const unlockAudio = () => {
  try {
    if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
  } catch (e) {
    /* audio not supported */
  }
};

// Pleasant two-tone chime generated with WebAudio (no audio file needed)
export const playChime = () => {
  try {
    unlockAudio();
    if (!ctx) return;
    const t = ctx.currentTime;
    [[880, 0], [1318.5, 0.16]].forEach(([freq, delay]) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = "sine";
      o.frequency.value = freq;
      g.gain.setValueAtTime(0.0001, t + delay);
      g.gain.exponentialRampToValueAtTime(0.35, t + delay + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, t + delay + 0.45);
      o.connect(g).connect(ctx.destination);
      o.start(t + delay);
      o.stop(t + delay + 0.5);
    });
  } catch (e) {
    /* ignore */
  }
};

export const notifySupported = () => typeof window !== "undefined" && "Notification" in window;

export const showNotification = (title, body, onClick) => {
  if (!notifySupported() || Notification.permission !== "granted") return;
  try {
    const n = new Notification(title, { body, icon: "/logo-icon.png", tag: "sw-chat", renotify: true });
    n.onclick = () => {
      window.focus();
      onClick?.();
      n.close();
    };
  } catch (e) {
    /* some browsers (mobile) block the constructor */
  }
};

export const getPref = (k, d = true) => {
  const v = localStorage.getItem(k);
  return v === null ? d : v === "1";
};
export const setPref = (k, v) => localStorage.setItem(k, v ? "1" : "0");
